import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'best-rental-deal',
  templateUrl: './best-rental-deal.component.html',
  styleUrls: ['./best-rental-deal.component.css']
})
export class BestRentalDealComponent implements OnInit {


  Partners = [
    {ImagePath:'assets/img/partners/Alamo-01.svg', ImageTooltip:'Partner 1'},
    {ImagePath:'assets/img/partners/avis_rgb_pos-01.svg', ImageTooltip:'Partner 2'},
    {ImagePath:'assets/img/partners/budget-01.svg', ImageTooltip:'Partner 3'},
    {ImagePath:'assets/img/partners/enterprise-01.svg', ImageTooltip:'Partner 4'},
    {ImagePath:'assets/img/partners/Eurocar.jpg', ImageTooltip:'Partner 5'},
    {ImagePath:'assets/img/partners/europcar_logo_vectoren-01.svg', ImageTooltip:'Partner 6'},
    {ImagePath:'assets/img/partners/firefly.jpg', ImageTooltip:'Partner 7'},
    {ImagePath:'assets/img/partners/Hertz.svg', ImageTooltip:'Partner 8'},
    {ImagePath:'assets/img/partners/MegaDrive.jpg', ImageTooltip:'Partner 9'},
    {ImagePath:'assets/img/partners/National_Car_Rental-01.svg', ImageTooltip:'Partner 10'},
    {ImagePath:'assets/img/partners/Payless-01.svg', ImageTooltip:'Partner 11'},
    {ImagePath:'assets/img/partners/Sixt-Logo.svg', ImageTooltip:'Partner 12'},
    {ImagePath:'assets/img/partners/Thrifty-01.svg', ImageTooltip:'Partner 13'},
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
